/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type TradeDesignManagerModal_user$ref = any;
export type TradeDesignManagerModal_user = {
    readonly serviceId: string | null;
    readonly tradeFirmDesignManagerProfile: {
        readonly hasAccount: unknown | null;
        readonly accountType: string | null;
    } | null;
    readonly socialNetworks: ReadonlyArray<{
        readonly status?: string | null;
    } | null> | null;
    readonly " $refType": TradeDesignManagerModal_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "TradeDesignManagerModal_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeFirmDesignManagerProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmDesignManagerProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasAccount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "accountType",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "socialNetworks",
      "storageKey": "socialNetworks(socialNetworkNames:\"DESIGN_MANAGER\")",
      "args": [
        {
          "kind": "Literal",
          "name": "socialNetworkNames",
          "value": "DESIGN_MANAGER"
        }
      ],
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "DesignManagerSocialNetworkType",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "status",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'a3bea0134d29871a67312b8996cbad2b';
export default node;
